import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AgreementType } from 'src/app/shared/enum';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';

@Component({
  selector: 'app-marketing-info',
  templateUrl: './marketing-info.component.html',
  styleUrls: ['./marketing-info.component.scss', '../../auth-connect/auth-connect.component.scss']
})
export class MarketingInfoComponent implements OnInit{
  @Input() userProfile!: any;
  @Output() userProfileChange = new EventEmitter<any>()
  @Input() elementName!: string;
  tenantName!: string;
  privacyPolicy = AgreementType.PolicyAgreement
  termsAndConditions = AgreementType.TermsAgreement

  constructor(
    private tenantService: TenantService,
  ) {}

  ngOnInit() {
    this.tenantService.getTenantAppConfig().subscribe((data: any) => {
      this.tenantName = data.name ?? '';
    });
  }

  onTermsClick(agreementType:string): void {
    if(agreementType === this.privacyPolicy)  window.open(window.location.origin+'/privacy')
    if(agreementType === this.termsAndConditions) window.open(window.location.origin+'/termsandconditions')
  }

}
